import { Component, OnChanges, ChangeDetectionStrategy, Input, Output, EventEmitter, SimpleChanges } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { Property } from '@app/shared/models/common-models'
import { PropertyChangeArgs } from '@app/shared/models/entity-update.model'
import { EntityService } from '@app/shared/services/entity.service'

@Component({
  selector: 'app-entity-list-property',
  templateUrl: './list-property.component.html',
  styleUrls: ['./list-property.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListPropertyComponent implements OnChanges {
  @Input() property: Property

  @Input() formGroup: UntypedFormGroup

  @Input() isRadioButton: boolean

  @Input() showMeasurementUnit = true

  @Input() showLabel = true

  @Input() showErrors = true

  @Output() propertyChange = new EventEmitter<PropertyChangeArgs>()

  propertyForm: UntypedFormControl

  toolTipTextId: string

  constructor(private entityService: EntityService) {
    this.propertyForm = new UntypedFormControl(null, { updateOn: 'change' })
    this.propertyForm.valueChanges.subscribe(value => {
      const event: PropertyChangeArgs = {
        Key: this.property.Key,
        Value: value,
        MeasurementUnitKey: this.property.MeasurementUnit,
      }
      this.propertyChange.emit(event)
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.property &&
      changes.formGroup &&
      changes.formGroup.currentValue &&
      changes.formGroup.previousValue !== changes.formGroup.currentValue
    ) {
      changes.formGroup.currentValue.setControl(this.property.Key, this.propertyForm, { emitEvent: false })
    }
    if (changes.property && this.property) {
      this.updatePropertyForm()
    }
  }

  updatePropertyForm() {
    /**
     * We don't update dirty fields if it has focus, or invalid value.
     * This is way we give user option to finish the input or fix validation error by not replacing the value which count up towards fluent user experience.
     * */
    if (this.propertyForm.pristine || this.propertyForm.valid) {
      this.propertyForm.setValue(this.property.Value, { emitEvent: false })
      this.propertyForm.markAsPristine()
    }

    if (this.property.IsEnabled && this.property.Items.length > 1) {
      this.propertyForm.enable({ emitEvent: false })
    } else {
      this.propertyForm.disable({ emitEvent: false })
    }

    this.propertyForm.updateValueAndValidity({ emitEvent: false })

    this.toolTipTextId = this.entityService.getMetadataValue(this.property, 'TooltipTextId')
  }
}
